import { render, staticRenderFns } from "./account-info.vue?vue&type=template&id=501fa800&scoped=true"
import script from "./account-info.vue?vue&type=script&lang=ts"
export * from "./account-info.vue?vue&type=script&lang=ts"
import style0 from "./account-info.vue?vue&type=style&index=0&id=501fa800&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501fa800",
  null
  
)

export default component.exports